<div class="inicio">
  
  <br>
  <p class="titulo"> 
    MANTENIMIENTO EVENTUAL
    <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
      <mat-icon>info</mat-icon> 
  </button>
  </p>
  
  <div class="columnas_1"><p class="advertencia">Campos obligatorios*</p></div>
  
  
  <div class="inputs_inicio">
    
    <mat-label class="labels">Sucursal <mat-label class="advertencia">*</mat-label> </mat-label>
    <mat-label class="labels"> Nombre del equipo <mat-label class="advertencia">*</mat-label> </mat-label>

    
    <mat-form-field appearance="fill">
        <mat-select [formControl]="input_sucursal" #singleSelect1 (selectionChange)="clickCargarSucursal($event)">
        <mat-option>
            <ngx-mat-select-search [formControl]="input_sucursal_nombre" oninput="this.value = this.value.toUpperCase()"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let option of listaFiltradaSucursales | async" [value]="option"> 
            {{option.nombreSucursal}} 
        </mat-option>
        </mat-select>
    </mat-form-field>
    

    <mat-form-field class="example-full-width" appearance="fill">
      <input type="text" matInput [formControl]="input___Equipo" placeholder="Ejem. SOF-GTI-LAP000" [matAutocomplete]="auto2"  oninput="this.value = this.value.toUpperCase()">
      <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete" (optionSelected)="click_Select_Equipo($event.option.value)">
          <mat-option *ngFor="let option of lista_equipos_filtrada | async" [value]="option"> {{option.name}} </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    
  </div>
  

  <div class="columnas_2">
    
    <form #insertForm="ngForm" [formGroup]="formulario">
      <div class="columnas_2__filas_6">

        <mat-label class="labels">Tipo de mantenimineto   </mat-label>
        <mat-label class="labels">Actividades realizadas  </mat-label>

        <mat-form-field appearance="fill">
          <mat-select formControlName="tipo_Mantenim" (selectionChange)="select_tipo_mantenimiento()">
            <mat-option *ngFor="let tipo_mantenimiento of lista_Tipos_Mantenimie" [value]="tipo_mantenimiento"> {{tipo_mantenimiento.nombre}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-select  multiple formControlName="actividad_Man">
            <mat-select-trigger>   
              <span *ngIf="formulario.value.actividad_Man?.length > 0" class="example-additional-selection">
                  Actividades seleccionadas
              </span>
            </mat-select-trigger>
            <mat-option  *ngFor="let actividad of lista_actividades_Mant" [value]="actividad">{{actividad.nombre_act}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-label class="labels">Comentarios del usuario </mat-label>
        <mat-label class="labels">Observaciones del equipo</mat-label>

        <mat-form-field class="example-full-width" appearance="fill">
          <input matInput formControlName="comentarios_U" >
        </mat-form-field>

        <mat-form-field class="example-full-width" appearance="fill">
          <input matInput formControlName="Observaciones">
        </mat-form-field>

        <mat-label      *ngIf="!verCampoProblema" class="labels">Problema o fallo</mat-label><div></div>
        <mat-form-field *ngIf="!verCampoProblema" class="example-full-width" appearance="fill">
          <input matInput formControlName="preblema_dete" >
        </mat-form-field>

        <div class="example-button-row" style="align-items: center;">
          <button mat-raised-button color="primary" [disabled]="!habilitar_boton()" (click)="click_pre_guardar($event)" >Agregar <mat-icon>add</mat-icon> </button>
        </div>

      </div>
    </form>
    
    <div class="columnas_1">
      <table mat-table [dataSource]="dataSourceME" class="mat-elevation-z8">

          
          <ng-container matColumnDef="OPCIONES">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab color="warn"   (click)="click_remover(element)" > <mat-icon>cancel</mat-icon> </button>
            </td>
          </ng-container>
        
          
          <ng-container matColumnDef="EQUIPO">
            <th mat-header-cell *matHeaderCellDef> EQUIPO </th>
            <td mat-cell *matCellDef="let element">
              {{element.equipo.name}}
            </td>
          </ng-container>
        
          
          <ng-container matColumnDef="TIPO DE MANTENIMIENTO">
            <th mat-header-cell *matHeaderCellDef> TIPO DE MANTENIMIENTO </th>
            <td mat-cell *matCellDef="let element"> 
              {{element.nombre_tipo_man}}
            </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
          <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>
      </table>
      <mat-paginator #paginatorME class="mat-elevation-z8" [pageSize]="10" showFirstLastButtons></mat-paginator>
    </div>

  </div>

  <div class="columna">

    <mat-label class="labels" >Observaciones generales</mat-label>
    <mat-form-field class="example-full-width" appearance="fill">
      <input matInput [formControl]="input_Observ_G" >
    </mat-form-field>

  </div>


  <div class="columnas_4__filas_2">
    
    
    <button mat-raised-button color="warn"    matTooltip="Cancela y sale sin guardar este mantenimeinto" (click)="clickCancelar($event)"  >Cancelar <mat-icon>cancel</mat-icon> </button>
    <div></div>
    <div></div>
    <button mat-raised-button color="primary" matTooltip="Guarda este mantenimeinto" (click)="clickGuardar($event)" [disabled]="!habilitar_boton_guardar_Todo()" >Guardar <mat-icon>save</mat-icon> </button>
    
  </div>

</div>